/**
 * IMPORTANT: there is nothing good in here, all of this should go away A S A P.
 * If you find yourself wanting to use a function out of this file,
 * or even worse wanting to make changes, PLEASE DO NOT!
 * Consider using something else or rewriting whatever component you're working with
 * that needs this. It's going to be much simpler.
 */
import { emptyFunction } from '../function';

const updateFieldValue = (form: any, fieldName: any, newInput: any) => {
  let obj = {};

  if (newInput && newInput.nativeEvent instanceof Event) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    obj[fieldName] = newInput.target.value;
    return form.setFieldsValue(obj);
  }

  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  obj[fieldName] = (newInput && newInput.value) || newInput;
  return form.setFieldsValue(obj);
};

const getFieldInitialValue = (fieldName: any, props: any) =>
  props.initialValues && props.initialValues[fieldName];

const getFieldObject = (fieldName: any, props: any, propertiesOverride = {}) => {
  const { form } = props;

  return {
    error: form.getFieldError(fieldName),
    onChange: (newInput: any) =>
      propertiesOverride.hasOwnProperty('onChange')
        ? // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type '{}'.
          propertiesOverride.onChange(form, fieldName, newInput)
        : updateFieldValue(form, fieldName, newInput),
    onUpdate: (newInput: any) =>
      propertiesOverride.hasOwnProperty('onUpdate')
        ? // @ts-expect-error ts-migrate(2339) FIXME: Property 'onUpdate' does not exist on type '{}'.
          propertiesOverride.onUpdate(form, fieldName, newInput)
        : updateFieldValue(form, fieldName, newInput),
    onFocus: (newInput: any) =>
      propertiesOverride.hasOwnProperty('onFocus')
        ? // @ts-expect-error ts-migrate(2339) FIXME: Property 'onFocus' does not exist on type '{}'.
          propertiesOverride.onFocus(form, fieldName, newInput)
        : updateFieldValue(form, fieldName, newInput),
    onBlur: (newInput: any) =>
      propertiesOverride.hasOwnProperty('onBlur')
        ? // @ts-expect-error ts-migrate(2339) FIXME: Property 'onBlur' does not exist on type '{}'.
          propertiesOverride.onBlur(form, fieldName, newInput)
        : updateFieldValue(form, fieldName, newInput),
    touched: form.isFieldTouched(fieldName),
    value: form.getFieldValue(fieldName),
    checked: form.getFieldValue(fieldName),
    initialValue: getFieldInitialValue(fieldName, props),
  };
};

const emptyInteractions = {
  onBlur: emptyFunction,
  onUpdate: emptyFunction,
  onFocus: emptyFunction,
};

export { getFieldObject, emptyInteractions };
